// extracted by mini-css-extract-plugin
export default {"container":"_1blth","time":"_1fCTY","title":"_3XygF","chevron":"_2dvdT"};